module.exports = __webpack_public_path__ + "img/shenjiguanli.230cd942.png";